const baseConfig = {
    maintainAspectRatio: false,
    scales: {
        y: {
            type: 'linear',
            display: true,
            position: 'left',
            grid: {
                color: 'rgba(0,0,0,.08)',
                drawBorder: false,
            },
            ticks: {
                color: 'rgba(0,0,0,.8)',
                font: { size: 13 },
            },
        },
        x: {
            grid: {
                color: 'rgba(0,0,0,0)',
                drawBorder: false,
            },
            ticks: {
                color: 'rgba(0,0,0,.8)',
                font: { size: 13 },
            },
            position: 'bottom',
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: true,
            position: 'top',
            color: '#3F3F3F',
            font: { size: 20 },
        },
        tooltip: {
            cornerRadius: 3,
            bodyFont: { size: 14 },
            titleFont: { size: 13 },
        },
    },
};

export default baseConfig;
